import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog'
import { SecondaryButton } from '@workspace/ui/components/dsm/secondary-button'
import { useToast } from '@workspace/ui/components/toast'
import { trackEvent } from '../../../../lib/gtag'
import { copy } from '../../copy/investor-copy'
import { useUnfollow } from '../../hooks/use-investor-assistant'
import { useSubmitOnce } from '../../hooks/use-submit-once'

/** Ends a follow: "Stop following" for one that runs, "Cancel follow" for one still waiting. */
export function StopDialog({
  startupId,
  startupName,
  waiting,
  onClose,
  onStopped,
}: {
  startupId: string
  startupName: string
  waiting: boolean
  onClose: () => void
  /** Called once the follow is stopped, so a search row can show it. */
  onStopped?: () => void
}) {
  const unfollow = useUnfollow()
  const toast = useToast()
  const once = useSubmitOnce(unfollow.isPending)
  const vars = { startup: startupName }
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{copy(waiting ? 'cancelFollow.title' : 'stop.title', vars)}</DialogTitle>
          <DialogDescription>
            {waiting ? copy('cancelFollow.body') : copy('stop.body', vars)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <SecondaryButton size="sm">
              {copy(waiting ? 'cancelFollow.keep' : 'stop.cancel')}
            </SecondaryButton>
          </DialogClose>
          <SecondaryButton
            size="sm"
            tone="danger"
            disabled={unfollow.isPending}
            onClick={() =>
              once(() => {
                trackEvent(waiting ? 'follow_cancelled' : 'assistant_follow_stopped', {
                  startup_id: startupId,
                })
                unfollow.mutate(
                  { path: { startupId } },
                  {
                    onSuccess: () => {
                      toast(waiting ? copy('toast.cancel.done') : copy('toast.stop.done', vars))
                      onStopped?.()
                      onClose()
                    },
                    onError: () => toast(copy('toast.stop.error', vars)),
                  }
                )
              })
            }
          >
            {copy(waiting ? 'cancelFollow.confirm' : 'stop.confirm')}
          </SecondaryButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
